import React from 'react';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons';

import { ADD } from '../../constant';

const HeaderView = ({ setVisibleFn, shoAddBtn, role }) => {
  const { t } = useTranslation();

  return (
    <div className="header">
      <h1>{t('cms.referral.payout_plan.title')}</h1>
      <If condition={shoAddBtn && role !== 'bd'}>
        <button
          className="button"
          type="button"
          onClick={() => {
            setVisibleFn(true, ADD);
          }}
        >
          <PlusOutlined className="icon" style={{ fontSize: '12px', marginLeft: '4px' }} />
          {t('cms.referral.payout_plan.button.add')}
        </button>
      </If>
    </div>
  );
};

export default HeaderView;
